import { FeedbackPopup } from "../popup/feedback-popup/feedback-popup";

export default new (class FeedbackSlider {
    constructor() {
        this.slider = ".fs-feedback-slider--list";
        this.feedbackPage = ".fs-feedback-list-page";

        if (!(document.querySelector(this.slider) || document.querySelector(this.feedbackPage))) return;

        this.addBtn = ".fs-feedback--create-btn";
        this.feedbackText = ".fs-feedback-slider--item-text";
        this.maxSymbolsCount = 400;
        this.FeedbackPopup =  new FeedbackPopup();

        this.eventsHandler();
        this.initSlider();
        this.checkFeedbackText();
    }

    eventsHandler() {
        document.querySelector(this.addBtn).addEventListener("click", this.handleOnAddBtnClick);
    }

    handleOnAddBtnClick = () => {
        this.FeedbackPopup.open();
    };

    checkFeedbackText() {
        let textList = document.querySelectorAll(this.feedbackText);

        textList.forEach(x => {
            let text = x.innerHTML;
            if (text.length > this.maxSymbolsCount) {
                let linkId = x.closest(".fs-feedback-slider--item").getAttribute("data-id");
                x.innerHTML = this.addEllipsisAndLinkToText(linkId, text, this.maxSymbolsCount);
            }
        });
    }

    addEllipsisAndLinkToText(linkId, text, limit) {
        let textArr = text.split("").splice(0, limit);
        textArr.push(`&#8230; <a href="/feedback-list#${linkId}"> читать полностью</a>`);
        return textArr.join("");
    }

    initSlider() {
        $(this.slider).slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 1000,
            slidesToScroll: 1,
            slidesToShow: 1,
            accessibility: false,
            autoplay: false,
            autoplaySpeed: 6000
        });
    }
})();
